import {
    css, Theme,
} from '@emotion/react'
import common from 'shared/styles'
import custom from 'shared/styles/custom.styles'

const styles = (theme: Theme) => {
    return {
        dialogContentRoot: css`
            ${common.flexJustityAlignCenter};
            padding: 0;
            height: 680px;
        `,
        text: css`
            padding-right: 15px;
            padding-left: 15px;
            padding-bottom: 40px;
        `,
        icon: css`
            width: 100%;
            min-width: 600px;
            min-height: 650px;
        `,
        actions: css``,
        button: css`
            ${custom.button};
            margin: 0 10px;
        `,
        message: css`
            ${custom.messageText};
            font-weight: ${theme.typography.fontWeightRegular};
        `,
        content: css`
            ${common.flexJustityAlignCenter};
            padding: 0;
            flex-direction: column;
        `,
    }
}

export default styles
